export const getUserRole = () => {
  try {
    const clientData = JSON.parse(localStorage.getItem("client_data"));
    if (!clientData || !clientData.client) return null;

    return clientData.client.is_master_user ? "MASTER_USER" : "ASSOCIATE_USER";
  } catch (error) {
    console.error("Error getting user role:", error);
    return null;
  }
};

export const isRouteRestricted = (pathname) => {
  const userRole = getUserRole();
  if (!userRole || userRole !== "MASTER_USER") return false;

  const restrictedRoutes = [
    "/market-deal/deals",
    "/indication-of-interest/ioi-tab",
    "/auto-match-deals/auto-match-tab",
    "/request-for-quote/rfq-tab",
  ];

  return restrictedRoutes.some((route) => pathname.includes(route));
};

export const hasPermissionForRoute = (permission) => {
  const userRole = getUserRole();
  if (!userRole) return false;

  const permissions = {
    canAccessMarketDeals: userRole !== "MASTER_USER",
    canAccessIOI: userRole !== "MASTER_USER",
    canAccessAutoMatchDeals: userRole !== "MASTER_USER",
    canAccessRFQ: userRole !== "MASTER_USER",
  };

  return permissions[permission] || false;
};
